import { Documento, ISdocumento } from "../../processo/Documento";
import { ISusuarioList, UsuarioList } from "../../usuario/UsuarioList";

export interface DocumentoAtualizaAndamento {
    id: string;
    descricao: string;
    usuario: UsuarioList;
    dataHoraCriacao: Date | null;
    documento: Documento;   
}

export const ISdocumentoAtualizaAndamento: DocumentoAtualizaAndamento = {
    id: "",
    descricao: "",
    usuario: ISusuarioList,
    dataHoraCriacao: null,
    documento: ISdocumento,
}